"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const controls_1 = require("~/components/common/controls");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const types_1 = require("~/store/types");
const ChangeCredentials_1 = require("../ChangeCredentials/ChangeCredentials");
const AddressEditModal_module_scss_1 = __importDefault(require("./AddressEditModal.module.scss"));
function AddressEditModal({ address = undefined, onClose, onSubmit, headlineHidden = false, isSubmitted, setDisabled: disable, distributorId, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { dispatchFetchData } = (0, redux_1.bindActionCreators)({ dispatchFetchData: actions_1.fetchData }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        dispatchFetchData(distributorId);
    }, []);
    const { t } = (0, react_i18next_1.useTranslation)('quote-widget');
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(true);
    const [addressLine, setAddressLine] = (0, react_1.useState)((_a = address === null || address === void 0 ? void 0 : address.addressLine) !== null && _a !== void 0 ? _a : '');
    const [addressLine2, setAddressLine2] = (0, react_1.useState)((_b = address === null || address === void 0 ? void 0 : address.addressLine2) !== null && _b !== void 0 ? _b : '');
    const [city, setCity] = (0, react_1.useState)((_c = address === null || address === void 0 ? void 0 : address.city) !== null && _c !== void 0 ? _c : '');
    const [state, setState] = (0, react_1.useState)((_d = address === null || address === void 0 ? void 0 : address.state) !== null && _d !== void 0 ? _d : '');
    const [zip, setZip] = (0, react_1.useState)((_e = address === null || address === void 0 ? void 0 : address.zip) !== null && _e !== void 0 ? _e : '');
    // TODO: remove hardcoded country id
    const usaCountryID = 230;
    const [currentCountryId, setCurrentCountryId] = (0, react_1.useState)((_g = (_f = address === null || address === void 0 ? void 0 : address.country) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : usaCountryID);
    const countries = (0, react_redux_1.useSelector)(selectors_1.selectCountries);
    const states = (0, react_redux_1.useSelector)(selectors_1.selectStates);
    const isDataLoading = (0, react_redux_1.useSelector)(selectors_1.selectIsDataLoading);
    const [statesForCountry, setStatesForCountry] = (0, react_1.useState)([]);
    const currentState = statesForCountry.length > 0 && state !== ''
        ? (_h = statesForCountry.find((stateForCountry) => stateForCountry.name === state)) !== null && _h !== void 0 ? _h : null
        : null;
    const countriesWithStates = [...new Set(states.map((st) => st.countryId))];
    (0, react_1.useEffect)(() => {
        const currentCountryStates = states.filter((currentCountryState) => currentCountryState.countryId === currentCountryId);
        if (countriesWithStates.includes(currentCountryId) && !currentCountryStates.length) {
            setState('');
        }
        setStatesForCountry(currentCountryStates);
    }, [currentCountryId, states]);
    const onAddressSubmit = () => {
        return {
            addressLine: addressLine.trim(),
            addressLine2: addressLine2.trim(),
            city: city.trim(),
            state,
            zip: zip.trim(),
            country_id: currentCountryId,
            id: address === null || address === void 0 ? void 0 : address.id,
        };
    };
    (0, react_1.useEffect)(() => {
        if (isSubmitted) {
            onSubmit(onAddressSubmit());
        }
    }, [isSubmitted]);
    (0, react_1.useEffect)(() => {
        const status = addressLine.trim() === '' ||
            city.trim() === '' ||
            state.trim() === '' ||
            zip.trim() === '' ||
            zip.trim().length < 3 ||
            !currentCountryId;
        setIsDisabled(status);
        if (disable) {
            disable(status);
        }
    }, [addressLine, city, state, zip, currentCountryId]);
    return isDataLoading === types_1.LOADING_STATE.COMPLETE ? (react_1.default.createElement("div", { className: AddressEditModal_module_scss_1.default.wrapper },
        headlineHidden ? null : (react_1.default.createElement("div", { className: AddressEditModal_module_scss_1.default.headline },
            react_1.default.createElement("span", null, !address ? t('title.adding-address') : t('title.editing-address')),
            (0, ChangeCredentials_1.profileButtons)(onClose, () => onSubmit(onAddressSubmit()), isDisabled, t))),
        react_1.default.createElement("form", null,
            react_1.default.createElement("label", { htmlFor: "street" }, t('title.detail')),
            react_1.default.createElement("div", { className: AddressEditModal_module_scss_1.default.inputBlock },
                react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.street'), value: addressLine, onChange: setAddressLine, onInput: setAddressLine, maxLength: 255, required: true })),
            react_1.default.createElement("div", { className: AddressEditModal_module_scss_1.default.inputBlock },
                react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.additional-line'), value: addressLine2, onChange: setAddressLine2, onInput: setAddressLine2, maxLength: 255 })),
            react_1.default.createElement("div", { className: AddressEditModal_module_scss_1.default.inputBlock },
                react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.city'), value: city, onChange: setCity, onInput: setCity, maxLength: 60, required: true })),
            react_1.default.createElement("div", { className: AddressEditModal_module_scss_1.default.inputBlock }, statesForCountry.length === 0 ? (react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.state'), value: state, onChange: setState, onInput: setState, maxLength: 60, required: true })) : (react_1.default.createElement(controls_1.FormDropdown, { inputKey: "state", state: { error: '', value: currentState ? { key: currentState.id, value: currentState.name } : null }, onInput: (key, id) => {
                    var _a, _b;
                    setState((_b = (_a = states.find((st) => st.id === id)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
                }, onError: () => {
                    console.log('state error');
                }, options: statesForCountry
                    ? statesForCountry.map((stateForCountry) => ({
                        key: stateForCountry.id,
                        value: stateForCountry.name,
                    }))
                    : [], placeholder: t('placeholder.shipping-address.state'), required: true }))),
            react_1.default.createElement("div", { className: AddressEditModal_module_scss_1.default.inputBlock },
                react_1.default.createElement(UI_1.Input, { placeholder: t('placeholder.shipping-address.zip'), value: zip, onChange: setZip, onInput: setZip, maxLength: 9, minLength: 3, required: true, customErrors: {
                        'min-value': t('shipping-address.zip-validation'),
                    } })),
            react_1.default.createElement("div", { className: AddressEditModal_module_scss_1.default.inputBlock },
                react_1.default.createElement(controls_1.FormDropdown, { inputKey: "country", state: {
                        value: currentCountryId
                            ? {
                                value: (_j = countries.find((country) => country.id === currentCountryId)) === null || _j === void 0 ? void 0 : _j.name,
                                key: currentCountryId,
                            }
                            : null,
                        error: '',
                    }, options: countries
                        ? [...countries]
                            .sort((a, b) => a.order - b.order)
                            .map((country) => ({
                            key: country.id,
                            value: country.name,
                        }))
                        : [], onInput: (key, id) => {
                        setCurrentCountryId(Number(id));
                    }, onError: () => console.log('country error'), placeholder: t('placeholder.shipping-address.country') }))))) : null;
}
AddressEditModal.defaultProps = {
    address: undefined,
    headlineHidden: undefined,
    isSubmitted: undefined,
    setDisabled: undefined,
    distributorId: undefined,
};
exports.default = AddressEditModal;
